module.exports = __webpack_public_path__ + "cu.svg?0d2f297f7fd5fbc687f8ee377aca5dfd";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/cu.svg
// module id = 977
// module chunks = 27